import { Login } from './Account/Login'
import { Profile } from './Profile'

export const Paths = [
    {
        path: '/Account/Login',
        component: Login,
    },
    {
        path: '/Account/ChangePassword',
        component: Profile,
    },
    {
        path: '/Profile',
        component: Profile,
    },
];
